export const DROPDOWN_MENU_STATE = {
  true: 'Aberto',
  false: 'Fechado',
}
